import { getProjectUserList } from '@/api/project'
import { getHospitalList } from '@/api/hospital'
import router from '@/router'
import store from '@/store'
import { getLabelList } from '@/api/label'
import { resolve } from 'url'
import { getItemInfo } from '@/api/item'
import { loadLabelTree, toFlatLabellist, INFINITY } from '@/utils/util'
import { getItemModelList } from '@/api/model'

const project = {
  state: {
    projectId: '',
    projectData: {},
    isProjectCreater: false,

    projectHospitals: [],
    projectUsers: [],
    globalLabelTrees: [],
    flatGlobalLabelList: [],
    localLabelTrees: [],
    flatLocalLabelList: [],
    diagnoseModels: []
  },

  mutations: {
    SET_PROJECT_ID: (state, projectId) => {
      state.projectId = projectId
    },
    SET_PROJECT_DATA: (state, projectData) => {
      state.projectData = projectData
    },
    SET_PROJECT_HOSPITALS: (state, hospitals) => {
      state.projectHospitals = hospitals
    },
    SET_PROJECT_USERS: (state, members) => {
      state.projectUsers = members
    },
    UPDATE_PROJECT_DATA: (state, updateItems) => {
      //debugger
      Object.assign(state.projectData, updateItems)
    },
    SET_IS_PROJECT_CREATER: (state) => {
      const user = store.getters.userInfo
      const createUserUid = state.projectData.createrId
      const isCreater = !!(user.uid == createUserUid ||
              user.role_id == 0 ||
              user.role_id == 1) // 开发者0，超级管理员1，普通用户2
      state.isProjectCreater = isCreater
    },
    SET_GLOBAL_LABELS: (state, labelTrees) => {
      state.globalLabelTrees = labelTrees
    },
    SET_FLAT_GLOBAL_LABELS: (state, labelList) => {
      state.flatGlobalLabelList = labelList
    },
    SET_LOCAL_LABELS: (state, labelTrees) => {
      state.localLabelTrees = labelTrees
    },
    SET_FLAT_LOCAL_LABELS: (state, labelList) => {
      state.flatLocalLabelList = labelList
    },
    SET_DIAGNOSE_MODELS: (state, diagnoseModels) => {
      state.diagnoseModels = diagnoseModels
    },

    CLEAN_PROJECT: (state) => {
      Object.assign(state, {
        projectId: '',
        projectData: {},
        isProjectCreater: false,

        projectHospitals: [],
        projectUsers: [],
        globalLabelTrees: [],
        flatGlobalLabelList: [],
        localLabelTrees: [],
        flatLocalLabelList: []
      })
    }
  },

  actions: {
    FetchProjectHospitals ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getHospitalList({ item_id: state.projectId, page_size: INFINITY })
          .then(res => {
            const hospitals = []
            if (!(res.data && res.data.length))hospitals.push({ key: '', value: '未添加来源', disabled: true })
            else {
              res.data.map(item => {
                hospitals.push({
                  key: item.source_id,
                  value: item.source_name
                })
              })
            }
            commit('SET_PROJECT_HOSPITALS', hospitals)
            resolve(hospitals)
          }).catch(err => {
            reject('获取数据来源失败')
          })
      })
    },
    FetchProjectUsers ({ commit, state }) {
      return new Promise((resolve, reject) => {
        return getProjectUserList({ item_id: state.projectId, page_size: INFINITY })
          .then(res => {
            const members = []
            if (!(res.data && res.data.length))resolve({ user_name: '未添加项目成员', uid: 'no_member' })
            res.data.map(user => {
              members.push({
                user_name: user.user_name,
                uid: user.member_uid,
                avatar: user.user_avatar
              })
            })
            commit('SET_PROJECT_USERS', members)
            resolve(members)
          }).catch(err => {
            reject('获取项目用户失败')
          })
      })
    },
    FetchGlobalLabelTrees ({ commit, state }) {
      return new Promise((resolve, reject) => {
        return getLabelList({ item_id: state.projectId, label_type: 1 })
          .then(res => {
            //debugger
            if (res.data.children.length == 0) return resolve({})
            const labelTrees = loadLabelTree(res.data.children)
            commit('SET_GLOBAL_LABELS', labelTrees)
            commit('SET_FLAT_GLOBAL_LABELS', toFlatLabellist(labelTrees))
            resolve({
              labelTrees: state.globalLabelTrees,
              flatLabelList: state.flatGlobalLabelList
            })
          }).catch(err => {
            reject('获取全局标注失败')
          })
      })
    },
    FetchLocalLabelTrees ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getLabelList({ item_id: state.projectId, label_type: 2 })
          .then(res => {
            //debugger
            if (res.data.children.length == 0) return resolve({})
            const labelTrees = loadLabelTree(res.data.children)
            commit('SET_LOCAL_LABELS', labelTrees)
            commit('SET_FLAT_LOCAL_LABELS', toFlatLabellist(labelTrees))
            resolve({
              labelTrees: state.localLabelTrees,
              flatLabelList: state.flatLocalLabelList
            })
          }).catch(err => {
            reject('获取局部标注失败')
          })
      })
    },
    FetchDiagnoseModels ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getItemModelList({ item_id: parseInt(state.projectId) })
          .then(res => {
            if (res.data.length == 0) return resolve({})
            commit('SET_DIAGNOSE_MODELS', res.data)
            resolve(res.data)
          }).catch(err => {
            reject('获取诊断模型失败')
          })
      })
    },
    UpdateProjectData ({ commit }, updateItems) {
      commit('UPDATE_PROJECT_DATA', updateItems)
    },

    CleanProject ({ commit }) {
      commit('CLEAN_PROJECT')
    },

    ToHome ({ state }, params = {}) {
      var { path, pageName, query } = params
      store.dispatch('CleanProject')
      store.commit('CONVERT_PAGE', 'homePage')
      if (typeof path !== 'undefined') router.replace({ path: path, query: query })
      else if (typeof pageName !== 'undefined') router.replace({ name: pageName, query: query })
    },

    ToProject ({ commit }, params = {}) {
      var { projectId, path, pageName, query } = params
      var query2 = Object.assign({}, query, { project_id: projectId })

      return new Promise((resolve) => {
        getItemInfo(projectId).then(res => {
          const projectData = {
            id: projectId,
            name: res.data.item.itemName,
            description: res.data.item.itemDes,
            createAt: res.data.item.createAt,
            createrName: res.data.user_name,
            createrId: res.data.item.createUid,
            permission: res.data.member_permission.split(','),
            labelType: res.data.item.labelType,
            sliceHeight: res.data.item.sliceHeight,
            sliceWidth: res.data.item.sliceWidth,
            imageType: res.data.item.imageType
          }
          store.dispatch('GenerateProjectRoutes', projectData.permission).then(() => {
            commit('SET_PROJECT_ID', projectId)
            commit('SET_PROJECT_DATA', projectData)
            commit('SET_IS_PROJECT_CREATER')
            store.dispatch('FetchProjectHospitals')
            store.dispatch('FetchProjectUsers')
            store.dispatch('FetchGlobalLabelTrees')
            store.dispatch('FetchLocalLabelTrees')
            if (typeof path !== 'undefined') router.replace({ path: path, query: query2 })
            else if (typeof pageName !== 'undefined') router.replace({ name: pageName, query: query2 })
            resolve()
          })
        })
      })
    }

  }
}

export default project
